/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  CloneSiteRequest,
  CreateSiteRequest,
  CreateSiteResponse,
  CreateStagingRequest,
  Error,
  FindSiteUsageParams,
  GetSiteUsageResponse,
  IDResponse,
  ListAllAvailableSiteLocationsParams,
  ListAllLocationsResponse,
  ListAvailableGenpopSiteLocationsParams,
  ListLocationsResponse,
  ListSiteTasksParams,
  ListSitesParams,
  ListSitesResponse,
  ListTasksResponse,
  PMALoginResponse,
  SettingsSchemaResponse,
  SiteAccessTokenRequest,
  SiteAccessTokenResponse,
  SiteCredentialsResponse,
  SiteID,
  SiteResponse,
  SiteSettingsResponse,
  SuccessResponse,
  TaskID,
  TaskIDResponse,
  UpdateSettingsRequest,
  UpdateSiteRequest,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns all sites on your account with key details such as domain, label, storage use, and status. Filter by domain or search by domain, label, or site ID.
 * @summary List your sites
 */
export const listSites = (params?: ListSitesParams, signal?: AbortSignal) => {
  return customFetch<ListSitesResponse>({ url: `/v1/sites`, method: 'GET', params, signal });
};

export const getListSitesQueryKey = (params?: ListSitesParams) => {
  return [`/v1/sites`, ...(params ? [params] : [])] as const;
};

export const getListSitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSites>>,
  TError = Error,
>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSites>>> = ({ signal }) =>
    listSites(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/sites`,
      operationId: 'app.controllers.sites_controller.list_sites',
      operationName: 'listSites',
    }
  );

  return customOptions as UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListSitesQueryResult = NonNullable<Awaited<ReturnType<typeof listSites>>>;
export type ListSitesQueryError = Error;

export function useListSites<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params: undefined | ListSitesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSites>>,
          TError,
          Awaited<ReturnType<typeof listSites>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSites<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSites>>,
          TError,
          Awaited<ReturnType<typeof listSites>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSites<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List your sites
 */

export function useListSites<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSitesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSitesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSites>>,
  TError = Error,
>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSitesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSites>>> = ({ signal }) =>
    listSites(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/sites`,
      operationId: 'app.controllers.sites_controller.list_sites',
      operationName: 'listSites',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSites>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSitesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listSites>>>;
export type ListSitesSuspenseQueryError = Error;

export function useListSitesSuspense<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params: undefined | ListSitesParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitesSuspense<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSitesSuspense<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List your sites
 */

export function useListSitesSuspense<TData = Awaited<ReturnType<typeof listSites>>, TError = Error>(
  params?: ListSitesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSites>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSitesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Provisions a new WordPress or static site in the region you choose. Set the site title, admin login, optional template, and plugins. New sites start on a temporary preview URL until you connect your own domain.
 * @summary Create a new site
 */
export const createSite = (createSiteRequest: CreateSiteRequest, signal?: AbortSignal) => {
  return customFetch<CreateSiteResponse>({
    url: `/v1/sites`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSiteRequest,
    signal,
  });
};

export const getCreateSiteMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSite>>,
    TError,
    { data: CreateSiteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSite>>,
  TError,
  { data: CreateSiteRequest },
  TContext
> => {
  const mutationKey = ['createSite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSite>>,
    { data: CreateSiteRequest }
  > = props => {
    const { data } = props ?? {};

    return createSite(data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites` },
    { operationId: 'app.controllers.sites_controller.create_site', operationName: 'createSite' }
  );

  return customOptions;
};

export type CreateSiteMutationResult = NonNullable<Awaited<ReturnType<typeof createSite>>>;
export type CreateSiteMutationBody = CreateSiteRequest;
export type CreateSiteMutationError = Error;

/**
 * @summary Create a new site
 */
export const useCreateSite = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSite>>,
      TError,
      { data: CreateSiteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSite>>,
  TError,
  { data: CreateSiteRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns both standard hosting regions and any dedicated regions assigned to your account. Use this when choosing where to create or clone a site.
 * @summary List all hosting regions
 */
export const listAllAvailableSiteLocations = (
  params?: ListAllAvailableSiteLocationsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListAllLocationsResponse>({
    url: `/v1/sites/all_locations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListAllAvailableSiteLocationsQueryKey = (
  params?: ListAllAvailableSiteLocationsParams
) => {
  return [`/v1/sites/all_locations`, ...(params ? [params] : [])] as const;
};

export const getListAllAvailableSiteLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllAvailableSiteLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>> = ({
    signal,
  }) => listAllAvailableSiteLocations(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/sites/all_locations`,
      operationId: 'app.controllers.sites_controller.list_all_available_site_locations',
      operationName: 'listAllAvailableSiteLocations',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAllAvailableSiteLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllAvailableSiteLocations>>
>;
export type ListAllAvailableSiteLocationsQueryError = Error;

export function useListAllAvailableSiteLocations<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params: undefined | ListAllAvailableSiteLocationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
          TError,
          Awaited<ReturnType<typeof listAllAvailableSiteLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllAvailableSiteLocations<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
          TError,
          Awaited<ReturnType<typeof listAllAvailableSiteLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllAvailableSiteLocations<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all hosting regions
 */

export function useListAllAvailableSiteLocations<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAllAvailableSiteLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAllAvailableSiteLocationsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAllAvailableSiteLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllAvailableSiteLocations>>> = ({
    signal,
  }) => listAllAvailableSiteLocations(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/sites/all_locations`,
      operationId: 'app.controllers.sites_controller.list_all_available_site_locations',
      operationName: 'listAllAvailableSiteLocations',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAllAvailableSiteLocationsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllAvailableSiteLocations>>
>;
export type ListAllAvailableSiteLocationsSuspenseQueryError = Error;

export function useListAllAvailableSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params: undefined | ListAllAvailableSiteLocationsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllAvailableSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAllAvailableSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all hosting regions
 */

export function useListAllAvailableSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
  TError = Error,
>(
  params?: ListAllAvailableSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAllAvailableSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAllAvailableSiteLocationsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the datacenter regions where you can create new sites. Optionally filter by site type. Use a location ID when creating or cloning a site.
 * @summary List hosting regions
 */
export const listAvailableGenpopSiteLocations = (
  params?: ListAvailableGenpopSiteLocationsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListLocationsResponse>({
    url: `/v1/sites/locations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListAvailableGenpopSiteLocationsQueryKey = (
  params?: ListAvailableGenpopSiteLocationsParams
) => {
  return [`/v1/sites/locations`, ...(params ? [params] : [])] as const;
};

export const getListAvailableGenpopSiteLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAvailableGenpopSiteLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>> = ({
    signal,
  }) => listAvailableGenpopSiteLocations(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/sites/locations`,
      operationId: 'app.controllers.sites_controller.list_available_genpop_site_locations',
      operationName: 'listAvailableGenpopSiteLocations',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAvailableGenpopSiteLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>
>;
export type ListAvailableGenpopSiteLocationsQueryError = Error;

export function useListAvailableGenpopSiteLocations<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params: undefined | ListAvailableGenpopSiteLocationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
          TError,
          Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAvailableGenpopSiteLocations<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
          TError,
          Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAvailableGenpopSiteLocations<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List hosting regions
 */

export function useListAvailableGenpopSiteLocations<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAvailableGenpopSiteLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAvailableGenpopSiteLocationsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAvailableGenpopSiteLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>> = ({
    signal,
  }) => listAvailableGenpopSiteLocations(params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { params },
    {
      url: `/v1/sites/locations`,
      operationId: 'app.controllers.sites_controller.list_available_genpop_site_locations',
      operationName: 'listAvailableGenpopSiteLocations',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAvailableGenpopSiteLocationsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>
>;
export type ListAvailableGenpopSiteLocationsSuspenseQueryError = Error;

export function useListAvailableGenpopSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params: undefined | ListAvailableGenpopSiteLocationsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAvailableGenpopSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAvailableGenpopSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List hosting regions
 */

export function useListAvailableGenpopSiteLocationsSuspense<
  TData = Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
  TError = Error,
>(
  params?: ListAvailableGenpopSiteLocationsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof listAvailableGenpopSiteLocations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAvailableGenpopSiteLocationsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns full details for one site, including its domain, preview URL, hosting region, storage use, connected domains, staging relationship, label, and status.
 * @summary Get site details
 */
export const findSite = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SiteResponse>({ url: `/v1/sites/${id}`, method: 'GET', signal });
};

export const getFindSiteQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}`] as const;
};

export const getFindSiteQueryOptions = <
  TData = Awaited<ReturnType<typeof findSite>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSite>>> = ({ signal }) =>
    findSite(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}`,
      operationId: 'app.controllers.sites_controller.find_site',
      operationName: 'findSite',
    }
  );

  return customOptions as UseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type FindSiteQueryResult = NonNullable<Awaited<ReturnType<typeof findSite>>>;
export type FindSiteQueryError = Error;

export function useFindSite<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSite>>,
          TError,
          Awaited<ReturnType<typeof findSite>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSite<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSite>>,
          TError,
          Awaited<ReturnType<typeof findSite>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSite<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site details
 */

export function useFindSite<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSite>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSite>>> = ({ signal }) =>
    findSite(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}`,
      operationId: 'app.controllers.sites_controller.find_site',
      operationName: 'findSite',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSite>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findSite>>>;
export type FindSiteSuspenseQueryError = Error;

export function useFindSiteSuspense<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSuspense<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSuspense<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site details
 */

export function useFindSiteSuspense<TData = Awaited<ReturnType<typeof findSite>>, TError = Error>(
  id: SiteID,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSite>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Permanently removes the site and all associated data, including website files, backups, and DNS records. This cannot be undone.
 * @summary Delete a site
 */
export const deleteSite = (id: SiteID) => {
  return customFetch<IDResponse>({ url: `/v1/sites/${id}`, method: 'DELETE' });
};

export const getDeleteSiteMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSite>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSite>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['deleteSite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSite>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return deleteSite(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}` },
    { operationId: 'app.controllers.sites_controller.delete_site', operationName: 'deleteSite' }
  );

  return customOptions;
};

export type DeleteSiteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSite>>>;

export type DeleteSiteMutationError = Error;

/**
 * @summary Delete a site
 */
export const useDeleteSite = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSite>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteSite>>, TError, { id: SiteID }, TContext> => {
  const mutationOptions = getDeleteSiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates editable site properties such as the display label, custom metadata, and site type. Useful for organizing sites in dashboards or agency workflows.
 * @summary Update site details
 */
export const modifySite = (id: SiteID, updateSiteRequest: UpdateSiteRequest) => {
  return customFetch<SiteResponse>({
    url: `/v1/sites/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateSiteRequest,
  });
};

export const getModifySiteMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifySite>>,
    TError,
    { id: SiteID; data: UpdateSiteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modifySite>>,
  TError,
  { id: SiteID; data: UpdateSiteRequest },
  TContext
> => {
  const mutationKey = ['modifySite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modifySite>>,
    { id: SiteID; data: UpdateSiteRequest }
  > = props => {
    const { id, data } = props ?? {};

    return modifySite(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}` },
    { operationId: 'app.controllers.sites_controller.modify_site', operationName: 'modifySite' }
  );

  return customOptions;
};

export type ModifySiteMutationResult = NonNullable<Awaited<ReturnType<typeof modifySite>>>;
export type ModifySiteMutationBody = UpdateSiteRequest;
export type ModifySiteMutationError = Error;

/**
 * @summary Update site details
 */
export const useModifySite = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof modifySite>>,
      TError,
      { id: SiteID; data: UpdateSiteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof modifySite>>,
  TError,
  { id: SiteID; data: UpdateSiteRequest },
  TContext
> => {
  const mutationOptions = getModifySiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Generates a short-lived access token scoped to this site. Use it to authenticate API requests for site-specific operations in integrations, scripts, or third-party tools.
 * @summary Create a site access token
 */
export const createSiteAccessToken = (
  id: SiteID,
  siteAccessTokenRequest?: SiteAccessTokenRequest,
  signal?: AbortSignal
) => {
  return customFetch<SiteAccessTokenResponse>({
    url: `/v1/sites/${id}/access_token`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: siteAccessTokenRequest,
    signal,
  });
};

export const getCreateSiteAccessTokenMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteAccessToken>>,
    TError,
    { id: SiteID; data: SiteAccessTokenRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteAccessToken>>,
  TError,
  { id: SiteID; data: SiteAccessTokenRequest },
  TContext
> => {
  const mutationKey = ['createSiteAccessToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteAccessToken>>,
    { id: SiteID; data: SiteAccessTokenRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteAccessToken(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/access_token` },
    {
      operationId: 'app.controllers.sites_controller.create_site_access_token',
      operationName: 'createSiteAccessToken',
    }
  );

  return customOptions;
};

export type CreateSiteAccessTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteAccessToken>>
>;
export type CreateSiteAccessTokenMutationBody = SiteAccessTokenRequest;
export type CreateSiteAccessTokenMutationError = Error;

/**
 * @summary Create a site access token
 */
export const useCreateSiteAccessToken = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteAccessToken>>,
      TError,
      { id: SiteID; data: SiteAccessTokenRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteAccessToken>>,
  TError,
  { id: SiteID; data: SiteAccessTokenRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteAccessTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Creates a copy of an existing site—content, themes, plugins, and settings included—as a new site with its own preview URL. Runs as a background task; use the tasks endpoint to track progress. WordPress sites only.
 * @summary Clone a WordPress site
 */
export const cloneSite = (id: number, cloneSiteRequest: CloneSiteRequest, signal?: AbortSignal) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/clone`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: cloneSiteRequest,
    signal,
  });
};

export const getCloneSiteMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneSite>>,
    TError,
    { id: number; data: CloneSiteRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneSite>>,
  TError,
  { id: number; data: CloneSiteRequest },
  TContext
> => {
  const mutationKey = ['cloneSite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneSite>>,
    { id: number; data: CloneSiteRequest }
  > = props => {
    const { id, data } = props ?? {};

    return cloneSite(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/clone` },
    { operationId: 'app.controllers.sites_controller.clone_site', operationName: 'cloneSite' }
  );

  return customOptions;
};

export type CloneSiteMutationResult = NonNullable<Awaited<ReturnType<typeof cloneSite>>>;
export type CloneSiteMutationBody = CloneSiteRequest;
export type CloneSiteMutationError = Error;

/**
 * @summary Clone a WordPress site
 */
export const useCloneSite = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cloneSite>>,
      TError,
      { id: number; data: CloneSiteRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cloneSite>>,
  TError,
  { id: number; data: CloneSiteRequest },
  TContext
> => {
  const mutationOptions = getCloneSiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the hosting username and password for the site, used for SFTP file access and related connections. WordPress sites only. Handle credentials securely.
 * @summary Get site login credentials
 */
export const findSiteCredentials = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SiteCredentialsResponse>({
    url: `/v1/sites/${id}/credentials`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteCredentialsQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/credentials`] as const;
};

export const getFindSiteCredentialsQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteCredentialsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteCredentials>>> = ({ signal }) =>
    findSiteCredentials(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/credentials`,
      operationId: 'app.controllers.sites_controller.find_site_credentials',
      operationName: 'findSiteCredentials',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteCredentials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteCredentialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteCredentials>>
>;
export type FindSiteCredentialsQueryError = Error;

export function useFindSiteCredentials<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteCredentials>>,
          TError,
          Awaited<ReturnType<typeof findSiteCredentials>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCredentials<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteCredentials>>,
          TError,
          Awaited<ReturnType<typeof findSiteCredentials>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCredentials<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site login credentials
 */

export function useFindSiteCredentials<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteCredentialsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteCredentialsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteCredentialsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteCredentials>>> = ({ signal }) =>
    findSiteCredentials(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/credentials`,
      operationId: 'app.controllers.sites_controller.find_site_credentials',
      operationName: 'findSiteCredentials',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteCredentials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteCredentialsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteCredentials>>
>;
export type FindSiteCredentialsSuspenseQueryError = Error;

export function useFindSiteCredentialsSuspense<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCredentialsSuspense<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCredentialsSuspense<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site login credentials
 */

export function useFindSiteCredentialsSuspense<
  TData = Awaited<ReturnType<typeof findSiteCredentials>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCredentials>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteCredentialsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Freezes the site so no new content or database changes can be saved. WARNING: Orders, comments, form submissions, and new posts will be blocked. Use for static sites or while fixing a security issue.

 * @summary Lock a site
 */
export const lockSite = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SuccessResponse>({ url: `/v1/sites/${id}/lock`, method: 'POST', signal });
};

export const getLockSiteMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockSite>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof lockSite>>, TError, { id: SiteID }, TContext> => {
  const mutationKey = ['lockSite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockSite>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return lockSite(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/lock` },
    { operationId: 'app.controllers.sites_controller.lock_site', operationName: 'lockSite' }
  );

  return customOptions;
};

export type LockSiteMutationResult = NonNullable<Awaited<ReturnType<typeof lockSite>>>;

export type LockSiteMutationError = Error;

/**
 * @summary Lock a site
 */
export const useLockSite = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lockSite>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof lockSite>>, TError, { id: SiteID }, TContext> => {
  const mutationOptions = getLockSiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Restores normal operation on a locked site so visitors can submit forms, place orders, and leave comments again.
 * @summary Unlock a site
 */
export const unlockSite = (id: SiteID) => {
  return customFetch<SuccessResponse>({ url: `/v1/sites/${id}/lock`, method: 'DELETE' });
};

export const getUnlockSiteMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockSite>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockSite>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['unlockSite'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockSite>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return unlockSite(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/lock` },
    { operationId: 'app.controllers.sites_controller.unlock_site', operationName: 'unlockSite' }
  );

  return customOptions;
};

export type UnlockSiteMutationResult = NonNullable<Awaited<ReturnType<typeof unlockSite>>>;

export type UnlockSiteMutationError = Error;

/**
 * @summary Unlock a site
 */
export const useUnlockSite = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unlockSite>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof unlockSite>>, TError, { id: SiteID }, TContext> => {
  const mutationOptions = getUnlockSiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns a one-time sign-in link to manage the site's MySQL database through phpMyAdmin. Intended for developers who need direct database access.
 * @summary Get database admin login link
 */
export const generateSitePmaLogin = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<PMALoginResponse>({ url: `/v1/sites/${id}/pma/login`, method: 'GET', signal });
};

export const getGenerateSitePmaLoginQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/pma/login`] as const;
};

export const getGenerateSitePmaLoginQueryOptions = <
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGenerateSitePmaLoginQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof generateSitePmaLogin>>> = ({ signal }) =>
    generateSitePmaLogin(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/pma/login`,
      operationId: 'app.controllers.sites_controller.generate_site_pma_login',
      operationName: 'generateSitePmaLogin',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof generateSitePmaLogin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GenerateSitePmaLoginQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateSitePmaLogin>>
>;
export type GenerateSitePmaLoginQueryError = Error;

export function useGenerateSitePmaLogin<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateSitePmaLogin>>,
          TError,
          Awaited<ReturnType<typeof generateSitePmaLogin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSitePmaLogin<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof generateSitePmaLogin>>,
          TError,
          Awaited<ReturnType<typeof generateSitePmaLogin>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSitePmaLogin<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get database admin login link
 */

export function useGenerateSitePmaLogin<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGenerateSitePmaLoginQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGenerateSitePmaLoginSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGenerateSitePmaLoginQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof generateSitePmaLogin>>> = ({ signal }) =>
    generateSitePmaLogin(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/pma/login`,
      operationId: 'app.controllers.sites_controller.generate_site_pma_login',
      operationName: 'generateSitePmaLogin',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof generateSitePmaLogin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GenerateSitePmaLoginSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof generateSitePmaLogin>>
>;
export type GenerateSitePmaLoginSuspenseQueryError = Error;

export function useGenerateSitePmaLoginSuspense<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSitePmaLoginSuspense<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGenerateSitePmaLoginSuspense<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get database admin login link
 */

export function useGenerateSitePmaLoginSuspense<
  TData = Awaited<ReturnType<typeof generateSitePmaLogin>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof generateSitePmaLogin>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGenerateSitePmaLoginSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns current site configuration such as PHP version, WordPress auto-update preferences, SSH access, activity logging, and the default admin user for one-click login.
 * @summary Get site settings
 */
export const findSiteSettings = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SiteSettingsResponse>({
    url: `/v1/sites/${id}/settings`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteSettingsQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/settings`] as const;
};

export const getFindSiteSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSettingsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSettings>>> = ({ signal }) =>
    findSiteSettings(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/settings`,
      operationId: 'app.controllers.site_settings_controller.find_site_settings',
      operationName: 'findSiteSettings',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof findSiteSettings>>>;
export type FindSiteSettingsQueryError = Error;

export function useFindSiteSettings<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSettings>>,
          TError,
          Awaited<ReturnType<typeof findSiteSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettings<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSettings>>,
          TError,
          Awaited<ReturnType<typeof findSiteSettings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettings<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site settings
 */

export function useFindSiteSettings<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSettingsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteSettingsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSettingsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSettings>>> = ({ signal }) =>
    findSiteSettings(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/settings`,
      operationId: 'app.controllers.site_settings_controller.find_site_settings',
      operationName: 'findSiteSettings',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSettingsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteSettings>>
>;
export type FindSiteSettingsSuspenseQueryError = Error;

export function useFindSiteSettingsSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettingsSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettingsSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site settings
 */

export function useFindSiteSettingsSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettings>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettings>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSettingsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Changes site configuration such as PHP version, WordPress core, theme, and plugin auto-updates, SSH access, and the default user used for admin login links. Only include the settings you want to change.
 * @summary Update site settings
 */
export const modifySiteSettings = (id: SiteID, updateSettingsRequest?: UpdateSettingsRequest) => {
  return customFetch<SiteSettingsResponse>({
    url: `/v1/sites/${id}/settings`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateSettingsRequest,
  });
};

export const getModifySiteSettingsMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modifySiteSettings>>,
    TError,
    { id: SiteID; data: UpdateSettingsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modifySiteSettings>>,
  TError,
  { id: SiteID; data: UpdateSettingsRequest },
  TContext
> => {
  const mutationKey = ['modifySiteSettings'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modifySiteSettings>>,
    { id: SiteID; data: UpdateSettingsRequest }
  > = props => {
    const { id, data } = props ?? {};

    return modifySiteSettings(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/settings` },
    {
      operationId: 'app.controllers.site_settings_controller.modify_site_settings',
      operationName: 'modifySiteSettings',
    }
  );

  return customOptions;
};

export type ModifySiteSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof modifySiteSettings>>
>;
export type ModifySiteSettingsMutationBody = UpdateSettingsRequest;
export type ModifySiteSettingsMutationError = Error;

/**
 * @summary Update site settings
 */
export const useModifySiteSettings = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof modifySiteSettings>>,
      TError,
      { id: SiteID; data: UpdateSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof modifySiteSettings>>,
  TError,
  { id: SiteID; data: UpdateSettingsRequest },
  TContext
> => {
  const mutationOptions = getModifySiteSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the list of configurable settings and their allowed values. Intended for building settings forms or validating update requests programmatically.
 * @summary Get available site settings
 */
export const findSiteSettingsSchema = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<SettingsSchemaResponse>({
    url: `/v1/sites/${id}/settings/schema`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteSettingsSchemaQueryKey = (id?: SiteID) => {
  return [`/v1/sites/${id}/settings/schema`] as const;
};

export const getFindSiteSettingsSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSettingsSchemaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSettingsSchema>>> = ({ signal }) =>
    findSiteSettingsSchema(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/settings/schema`,
      operationId: 'app.controllers.site_settings_controller.find_site_settings_schema',
      operationName: 'findSiteSettingsSchema',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteSettingsSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSettingsSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteSettingsSchema>>
>;
export type FindSiteSettingsSchemaQueryError = Error;

export function useFindSiteSettingsSchema<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSettingsSchema>>,
          TError,
          Awaited<ReturnType<typeof findSiteSettingsSchema>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettingsSchema<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteSettingsSchema>>,
          TError,
          Awaited<ReturnType<typeof findSiteSettingsSchema>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettingsSchema<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get available site settings
 */

export function useFindSiteSettingsSchema<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSettingsSchemaQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteSettingsSchemaSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteSettingsSchemaQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteSettingsSchema>>> = ({ signal }) =>
    findSiteSettingsSchema(id, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id },
    {
      url: `/v1/sites/${id}/settings/schema`,
      operationId: 'app.controllers.site_settings_controller.find_site_settings_schema',
      operationName: 'findSiteSettingsSchema',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteSettingsSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteSettingsSchemaSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteSettingsSchema>>
>;
export type FindSiteSettingsSchemaSuspenseQueryError = Error;

export function useFindSiteSettingsSchemaSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettingsSchemaSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteSettingsSchemaSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get available site settings
 */

export function useFindSiteSettingsSchemaSuspense<
  TData = Awaited<ReturnType<typeof findSiteSettingsSchema>>,
  TError = Error,
>(
  id: SiteID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteSettingsSchema>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteSettingsSchemaSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a safe copy of your live site where you can test changes before going live. Runs as a background task. Optionally request a custom staging domain instead of the default preview URL.
 * @summary Create a staging site
 */
export const createSiteStaging = (
  id: SiteID,
  createStagingRequest: CreateStagingRequest,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/staging`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createStagingRequest,
    signal,
  });
};

export const getCreateSiteStagingMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteStaging>>,
    TError,
    { id: SiteID; data: CreateStagingRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteStaging>>,
  TError,
  { id: SiteID; data: CreateStagingRequest },
  TContext
> => {
  const mutationKey = ['createSiteStaging'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteStaging>>,
    { id: SiteID; data: CreateStagingRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteStaging(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/staging` },
    {
      operationId: 'app.controllers.sites_controller.create_site_staging',
      operationName: 'createSiteStaging',
    }
  );

  return customOptions;
};

export type CreateSiteStagingMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteStaging>>
>;
export type CreateSiteStagingMutationBody = CreateStagingRequest;
export type CreateSiteStagingMutationError = Error;

/**
 * @summary Create a staging site
 */
export const useCreateSiteStaging = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteStaging>>,
      TError,
      { id: SiteID; data: CreateStagingRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteStaging>>,
  TError,
  { id: SiteID; data: CreateStagingRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteStagingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Removes the staging copy of the site. Your live production site is not affected.
 * @summary Delete staging site
 */
export const deleteSiteStaging = (id: SiteID) => {
  return customFetch<SuccessResponse>({ url: `/v1/sites/${id}/staging`, method: 'DELETE' });
};

export const getDeleteSiteStagingMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteStaging>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteStaging>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['deleteSiteStaging'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteStaging>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return deleteSiteStaging(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/staging` },
    {
      operationId: 'app.controllers.sites_controller.delete_site_staging',
      operationName: 'deleteSiteStaging',
    }
  );

  return customOptions;
};

export type DeleteSiteStagingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteStaging>>
>;

export type DeleteSiteStagingMutationError = Error;

/**
 * @summary Delete staging site
 */
export const useDeleteSiteStaging = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteStaging>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteStaging>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationOptions = getDeleteSiteStagingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Copies approved changes from your staging site to the live production site. Runs as a background task. Use when you are ready to make tested changes public.
 * @summary Push staging to live
 */
export const publishSiteStaging = (id: SiteID, signal?: AbortSignal) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/staging/publish`,
    method: 'POST',
    signal,
  });
};

export const getPublishSiteStagingMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishSiteStaging>>,
    TError,
    { id: SiteID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishSiteStaging>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationKey = ['publishSiteStaging'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishSiteStaging>>,
    { id: SiteID }
  > = props => {
    const { id } = props ?? {};

    return publishSiteStaging(id);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/staging/publish` },
    {
      operationId: 'app.controllers.sites_controller.publish_site_staging',
      operationName: 'publishSiteStaging',
    }
  );

  return customOptions;
};

export type PublishSiteStagingMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishSiteStaging>>
>;

export type PublishSiteStagingMutationError = Error;

/**
 * @summary Push staging to live
 */
export const usePublishSiteStaging = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publishSiteStaging>>,
      TError,
      { id: SiteID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof publishSiteStaging>>,
  TError,
  { id: SiteID },
  TContext
> => {
  const mutationOptions = getPublishSiteStagingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns background jobs for the site, such as cloning, staging creation, backups, and restores. Filter by task type, status, or ID. Includes progress percentage and status messages.
 * @summary List site background tasks
 */
export const listSiteTasks = (id: SiteID, params?: ListSiteTasksParams, signal?: AbortSignal) => {
  return customFetch<ListTasksResponse>({
    url: `/v1/sites/${id}/tasks`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteTasksQueryKey = (id?: SiteID, params?: ListSiteTasksParams) => {
  return [`/v1/sites/${id}/tasks`, ...(params ? [params] : [])] as const;
};

export const getListSiteTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteTasks>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteTasksQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteTasks>>> = ({ signal }) =>
    listSiteTasks(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/tasks`,
      operationId: 'app.controllers.sites_controller.list_site_tasks',
      operationName: 'listSiteTasks',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteTasksQueryResult = NonNullable<Awaited<ReturnType<typeof listSiteTasks>>>;
export type ListSiteTasksQueryError = Error;

export function useListSiteTasks<TData = Awaited<ReturnType<typeof listSiteTasks>>, TError = Error>(
  id: SiteID,
  params: undefined | ListSiteTasksParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteTasks>>,
          TError,
          Awaited<ReturnType<typeof listSiteTasks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteTasks<TData = Awaited<ReturnType<typeof listSiteTasks>>, TError = Error>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteTasks>>,
          TError,
          Awaited<ReturnType<typeof listSiteTasks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteTasks<TData = Awaited<ReturnType<typeof listSiteTasks>>, TError = Error>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List site background tasks
 */

export function useListSiteTasks<TData = Awaited<ReturnType<typeof listSiteTasks>>, TError = Error>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteTasksQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteTasksSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteTasks>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteTasksQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteTasks>>> = ({ signal }) =>
    listSiteTasks(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/tasks`,
      operationId: 'app.controllers.sites_controller.list_site_tasks',
      operationName: 'listSiteTasks',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteTasksSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteTasks>>
>;
export type ListSiteTasksSuspenseQueryError = Error;

export function useListSiteTasksSuspense<
  TData = Awaited<ReturnType<typeof listSiteTasks>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteTasksParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteTasksSuspense<
  TData = Awaited<ReturnType<typeof listSiteTasks>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteTasksSuspense<
  TData = Awaited<ReturnType<typeof listSiteTasks>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List site background tasks
 */

export function useListSiteTasksSuspense<
  TData = Awaited<ReturnType<typeof listSiteTasks>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteTasksParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteTasks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteTasksSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Marks a long-running or timed-out background task as cancelled. Only available after the task has exceeded its allowed runtime. Does not undo work already completed.
 * @summary Cancel a stuck task
 */
export const cancelSiteTask = (id: SiteID, taskId: TaskID, signal?: AbortSignal) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/tasks/${taskId}/cancel`,
    method: 'POST',
    signal,
  });
};

export const getCancelSiteTaskMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelSiteTask>>,
    TError,
    { id: SiteID; taskId: TaskID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelSiteTask>>,
  TError,
  { id: SiteID; taskId: TaskID },
  TContext
> => {
  const mutationKey = ['cancelSiteTask'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelSiteTask>>,
    { id: SiteID; taskId: TaskID }
  > = props => {
    const { id, taskId } = props ?? {};

    return cancelSiteTask(id, taskId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/tasks/{taskId}/cancel` },
    {
      operationId: 'app.controllers.sites_controller.cancel_site_task',
      operationName: 'cancelSiteTask',
    }
  );

  return customOptions;
};

export type CancelSiteTaskMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSiteTask>>>;

export type CancelSiteTaskMutationError = Error;

/**
 * @summary Cancel a stuck task
 */
export const useCancelSiteTask = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelSiteTask>>,
      TError,
      { id: SiteID; taskId: TaskID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cancelSiteTask>>,
  TError,
  { id: SiteID; taskId: TaskID },
  TContext
> => {
  const mutationOptions = getCancelSiteTaskMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns visitor count, bandwidth, and disk storage for the site. Optionally limit results to a date range to track usage over time.
 * @summary Get site usage stats
 */
export const findSiteUsage = (id: SiteID, params?: FindSiteUsageParams, signal?: AbortSignal) => {
  return customFetch<GetSiteUsageResponse>({
    url: `/v1/sites/${id}/usage`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFindSiteUsageQueryKey = (id?: SiteID, params?: FindSiteUsageParams) => {
  return [`/v1/sites/${id}/usage`, ...(params ? [params] : [])] as const;
};

export const getFindSiteUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteUsage>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteUsage>>> = ({ signal }) =>
    findSiteUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/usage`,
      operationId: 'app.controllers.sites_controller.find_site_usage',
      operationName: 'findSiteUsage',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteUsageQueryResult = NonNullable<Awaited<ReturnType<typeof findSiteUsage>>>;
export type FindSiteUsageQueryError = Error;

export function useFindSiteUsage<TData = Awaited<ReturnType<typeof findSiteUsage>>, TError = Error>(
  id: SiteID,
  params: undefined | FindSiteUsageParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteUsage>>,
          TError,
          Awaited<ReturnType<typeof findSiteUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteUsage<TData = Awaited<ReturnType<typeof findSiteUsage>>, TError = Error>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteUsage>>,
          TError,
          Awaited<ReturnType<typeof findSiteUsage>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteUsage<TData = Awaited<ReturnType<typeof findSiteUsage>>, TError = Error>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site usage stats
 */

export function useFindSiteUsage<TData = Awaited<ReturnType<typeof findSiteUsage>>, TError = Error>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteUsageQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteUsageSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteUsage>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteUsageQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteUsage>>> = ({ signal }) =>
    findSiteUsage(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/usage`,
      operationId: 'app.controllers.sites_controller.find_site_usage',
      operationName: 'findSiteUsage',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteUsageSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteUsage>>
>;
export type FindSiteUsageSuspenseQueryError = Error;

export function useFindSiteUsageSuspense<
  TData = Awaited<ReturnType<typeof findSiteUsage>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | FindSiteUsageParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteUsageSuspense<
  TData = Awaited<ReturnType<typeof findSiteUsage>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteUsageSuspense<
  TData = Awaited<ReturnType<typeof findSiteUsage>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get site usage stats
 */

export function useFindSiteUsageSuspense<
  TData = Awaited<ReturnType<typeof findSiteUsage>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteUsageParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteUsage>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteUsageSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
